{
  "layout": {
    "title": "Configuración",
    "description": "Gestione la configuración y preferencias de su cuenta.",
    "adminTitle": "Configuración",
    "adminDescription": "Gestione la configuración y preferencias de su cuenta administrativa."
  },
  "nav": {
    "profile": "Perfil",
    "business": "Negocio",
    "password": "Contraseña",
    "appearance": "Apariencia",
    "language": "Idioma",
    "notifications": "Notificaciones",
    "billing": "Facturación"
  },
  "profile": {
    "title": "Perfil",
    "description": "Actualice su información personal",
    "formTitle": "Información del perfil",
    "formDescription": "Actualice su nombre, correo electrónico y número de teléfono",
    "saving": "Guardando...",
    "saved": "Perfil actualizado correctamente",
    "saveError": "Error al actualizar el perfil",
    "name": "Nombre",
    "nameDescription": "Su nombre completo",
    "namePlaceholder": "Nombre completo",
    "email": "Correo electrónico",
    "emailDescription": "Su dirección de correo electrónico",
    "emailPlaceholder": "Correo electrónico",
    "phone": "Número de teléfono",
    "phoneDescription": "Su número de teléfono con código de país",
    "phonePlaceholder": "Número de teléfono",
    "invalidUsername": "El nombre de usuario debe tener entre 3 y 30 caracteres: letras minúsculas, números y guiones bajos",
    "username": "Nombre de usuario",
    "usernameDescription": "Se usa para iniciar sesión. Puede cambiarlo en cualquier momento.",
    "usernamePlaceholder": "nombredeusuario",
    "usernameChecking": "Comprobando disponibilidad...",
    "usernameAvailable": "El nombre de usuario está disponible",
    "invalidEmail": "Correo electrónico no válido",
    "legacyTitle": "Perfil de usuario",
    "firstLastName": "Nombre y apellido",
    "phoneRequired": "El teléfono no puede estar vacío",
    "changePasswordButton": "Cambiar contraseña",
    "photo": "Foto de perfil",
    "photoDescription": "Suba una foto para su perfil",
    "uploading": "Subiendo...",
    "uploadFailed": "Error al subir"
  },
  "business": {
    "title": "Configuración del perfil del negocio",
    "description": "Gestione la información y datos de contacto de su negocio",
    "loadingTitle": "Perfil del negocio",
    "loadingDescription": "Gestione la información de su negocio",
    "noBusinessTitle": "Perfil del negocio",
    "noBusinessDescription": "Ningún negocio seleccionado",
    "noBusinessHint": "Seleccione un negocio para gestionar su perfil.",
    "updating": "Actualizando...",
    "update": "Actualizar",
    "saved": "Perfil actualizado correctamente",
    "uploadFailed": "Error al subir",
    "uploading": "Subiendo...",
    "geocodeError": "No se pudo resolver esta dirección. Elija una sugerencia de la lista.",
    "imageAlt": "Negocio",
    "name": "Nombre del negocio",
    "namePlaceholder": "Nombre de su negocio",
    "descriptionLabel": "Descripción del negocio",
    "descriptionPlaceholder": "Describa su negocio",
    "location": "Ubicación",
    "locationHint": "Comience a escribir su dirección y elija una sugerencia de la lista.",
    "locationPlaceholder": "p. ej. Calle Principal 123, Accra",
    "email": "Correo del negocio",
    "emailPlaceholder": "contacto@negocio.com",
    "emailRequired": "El correo es obligatorio",
    "emailInvalid": "El correo no es válido",
    "phone": "Teléfono del negocio",
    "phonePlaceholder": "+1234567890",
    "industry": "Industria",
    "industryHint": "Seleccione la industria de su negocio",
    "industryPlaceholder": "Seleccionar una industria",
    "industrySearch": "Buscar industrias...",
    "industryEmpty": "No se encontró ninguna industria"
  },
  "password": {
    "title": "Contraseña",
    "description": "Actualice su contraseña",
    "formTitle": "Cambiar contraseña",
    "formDescription": "Asegúrese de que su cuenta use una contraseña larga y aleatoria para mantenerse segura",
    "current": "Contraseña actual",
    "new": "Nueva contraseña",
    "confirm": "Confirmar contraseña",
    "saved": "Contraseña actualizada correctamente",
    "saveError": "Error al actualizar la contraseña",
    "saving": "Guardando...",
    "saveButton": "Guardar contraseña",
    "minLength": "Debe tener 8 caracteres o más",
    "mismatch": "Las contraseñas deben coincidir",
    "legacyTitle": "Establecer nueva contraseña",
    "legacyDescription": "Ingrese su contraseña anterior y proporcione una nueva contraseña",
    "legacyBack": "Volver",
    "oldPasswordPlaceholder": "Ingrese su contraseña anterior",
    "newPasswordPlaceholder": "Ingrese su nueva contraseña",
    "confirmPasswordPlaceholder": "Confirme su nueva contraseña",
    "changeSuccess": "Contraseña cambiada correctamente",
    "changeFailed": "Error al cambiar la contraseña"
  },
  "appearance": {
    "title": "Apariencia",
    "description": "Actualice la configuración de apariencia de su cuenta",
    "theme": "Tema",
    "themeDescription": "Seleccione su tema preferido para la aplicación.",
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "language": {
    "title": "Idioma",
    "description": "Elija su idioma preferido para la aplicación.",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "saved": "Idioma actualizado",
    "active": "Activo"
  },
  "notifications": {
    "title": "Notificaciones",
    "description": "Vea y gestione su actividad reciente y alertas.",
    "emptyTitle": "Aún no hay notificaciones",
    "emptyDescription": "Cuando reciba actualizaciones de citas, solicitudes de horario y otras alertas, aparecerán aquí.",
    "updating": "Actualizando notificación…",
    "pageOf": "Página {{page}} de {{total}}",
    "markAllSuccess": "Todas las notificaciones marcadas como leídas",
    "markAllError": "No se pudieron marcar las notificaciones como leídas",
    "markReadError": "No se pudo marcar la notificación como leída"
  }
}
